/**
 * 结算单状态
 */
enum SettlementState {
    // 发送状态
    已创建 = 'CREATED',
    已发送 = 'SENDED',
    已接受 = 'ACCEPTED',
    已拒绝 = 'REFUSED',
    已作废 = 'INVALID',
    //  匹配状态
    匹配中 = 'MATCHING',
    未匹配 = 'NOTMATCH',
    已匹配 = 'MATCHFINISH',
}
export {SettlementState};



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/Modules.Constant.ts